import React, { memo, useEffect, useRef, useState } from "react";
import { SlimNav } from "@t8891/business";
import { useAtom } from "jotai";
import { initTracking } from "@Lib/jotai/tracking";
import SecondaryNav from "./secondary";

const WebsiteNav: React.FC<any> = ({ children }) => {
  const [tracking] = useAtom(initTracking);
  const [isLoaded, setIsLoaded] = useState(false);

  const handleAfterLoad = () => {
    setIsLoaded(true);
  };

  useEffect(() => {
    window.addEventListener("load", handleAfterLoad);
    return () => {
      window.removeEventListener("load", handleAfterLoad);
    };
  }, []);

  return (
    <>
      {children}
      {/* 层级大于999将会影响到toast被遮挡 */}
      <div id='website-nav' className='sticky top-0 z-[100]'>
        {isLoaded && (
          <SlimNav
            onExposured={() => {
              setTimeout(() => {
                tracking?.trackEvent({
                  name: "element_exposured",
                  params: {
                    page_business: "新車",
                    trigger_id: "2529",
                    page_id: "619",
                    trigger_name: "買車頁",
                    next_spm: "2.619.482.1024",
                    page: "全站導航",
                    channel: "首頁",
                    element_id: "買車頁",
                    element: "按鈕",
                    module: "一級導航",
                    tracker_method: "config",
                  },
                });
              }, 1000);
            }}
            onClickBuyCar={() => {
              tracking.trackEvent({
                name: "element_clicked",
                params: {
                  page_business: "新車",
                  trigger_id: "2499",
                  page_id: "619",
                  trigger_name: "買車頁",
                  next_spm: "2.619.482.1024",
                  page: "全站導航",
                  channel: "首頁",
                  element_id: "買車頁",
                  element: "按鈕",
                  module: "一級導航",
                  tracker_method: "config",
                  expand: "買新車",
                },
              });
            }}
          />
        )}
        <SecondaryNav />
      </div>
    </>
  );
};

export default memo(WebsiteNav);
